import React, { useState } from 'react';

import RelationMap from '../../graph/force-directed-tree/RelationMap';
import Line from '../../graph/line/Line';
import QuickTopKeywordTable from './QuickTopKeywordTable';

import './QuickMain.css'
import SpinnerBox from '../../spinner-box/SpinnerBox';

const KeywordRelationMap = (props) => {
  return(
    <RelationMap width={props.width} height={props.height} data={props.data} />
  )
}

const BuzzLineGraph = (props) => {
  return(
    <Line width={props.width} height={props.height} data={props.data} />
  )
}

const QuickMain = (props) => {
  return (
    <div className="row featured-main">
      <table className="quick_tablesty_Noline">
        <tr>
          <td rowspan="2" width="50%" className="rightpadding">
            <div className="graphTit"><span className="purple">일간 언급량 기준</span> 상위 키워드</div>
            <div className="graphBox">
              {/* <QuickTopKeywordTable data={props.data} handleOnClick={props.handleOnClick}/> */}
              {props.data.loaded == false ?
                <SpinnerBox width="100%" height={1200}/>
                :<QuickTopKeywordTable data={props.data.mainData} handleOnClick={props.handleOnClick}/>}
            </div>
          </td>
          <td className="right" height="50%">
            <div className="graphTit"><span className="purple">핵심 키워드</span> 연관어</div>
            <div className="graphBox2">
            {/* <KeywordRelationMap width="100%" height={500} data={props.mapData} /> */}
              {props.mapData.loaded == false ?
                <SpinnerBox width="100%" height={500}/>
                :<KeywordRelationMap width="100%" height={500} data={props.mapData.relationMapData} />}
            </div>
          </td>
        </tr>
        <tr>
          <td className="right" height="50%">
            <div className="graphTit"><span className="purple">채널 버즈량</span> 추이</div>
            <div className="graphBox2">
            {/* <BuzzLineGraph width="100%" height={500} data={props.lineData} /> */}
              {props.lineData.loaded == false ?
                <SpinnerBox width="100%" height={500}/>
                :<BuzzLineGraph width="100%" height={500} data={props.lineData.lineData} />}
            </div>
          </td>
        </tr>
      </table>
    </div>
  )
}

export default QuickMain;
